import {
  StoreReviewStatusSchema,
  type StoreReviewStatus as GeneratedStoreReviewStatus
} from '~/services/api/generated'

// Mirrors backend App\Enums\Store\StoreReviewStatus

export type StoreReviewStatus = GeneratedStoreReviewStatus

export const StoreReviewStatus = {
  PENDING: StoreReviewStatusSchema.enum.pending,
  APPROVED: StoreReviewStatusSchema.enum.approved,
  REJECTED: StoreReviewStatusSchema.enum.rejected
} satisfies Record<string, GeneratedStoreReviewStatus>

export const StoreReviewStatusValues: readonly GeneratedStoreReviewStatus[] = [
  StoreReviewStatusSchema.enum.pending,
  StoreReviewStatusSchema.enum.approved,
  StoreReviewStatusSchema.enum.rejected
]
